module.exports = "/_next/static/images/financial-accounting-header-b2bd50c2db37a98d160839861de9c9c6.webp";